import { CreateSchedule } from "@coworker/apprestructured/src/task-management/types/Schedule";
import {
  createAuthorizationHeader,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";
import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";

const BASE_URL = `${TASKS_SERVICE_URL}/schedules`;

// Returns the first task in the schedule
export async function createSchedule(createSchedule: CreateSchedule) {
  return toJson<Task>(
    await fetch(BASE_URL, {
      method: "POST",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
      body: JSON.stringify(createSchedule),
    })
  );
}
